import { render, staticRenderFns } from "./GlobalLoader.vue?vue&type=template&id=0822c672&scoped=true&"
var script = {}
import style0 from "./GlobalLoader.vue?vue&type=style&index=0&id=0822c672&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0822c672",
  null
  
)

export default component.exports